// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"VvA0y79d"};